import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';

import { NOPING_GREEN } from '../constants';

interface MatrixColumn {
  x: number;
  speed: number;
  chars: string[];
  delay: number;
  bright: boolean;
}

export function MatrixBg() {
  const [columns, setColumns] = useState<MatrixColumn[]>([]);

  useEffect(() => {
    const cols: MatrixColumn[] = [];
    const charSets = '01NoPing><%#@&*!\u30A2\u30A4\u30A6\u30A8\u30AA';
    for (let i = 0; i < 50; i += 1) {
      const chars: string[] = [];
      for (let j = 0; j < 30; j += 1) chars.push(charSets[Math.floor(Math.random() * charSets.length)]!);
      cols.push({ x: (i * 2.04) % 100, speed: 10 + (i % 5) * 4, chars, delay: (i % 10) * 1.0, bright: i % 5 === 0 });
    }
    setColumns(cols);
  }, []);

  return (
    <div className='pointer-events-none absolute inset-0 overflow-hidden' style={{ zIndex: 0 }}>
      <div className='absolute inset-x-0 top-0 h-1/5 opacity-[0.04]' style={{ background: `radial-gradient(ellipse 80% 60% at 50% 0%, ${NOPING_GREEN}, transparent)` }} />
      {columns.map((col, i) => (
        <motion.div key={i} className='absolute font-mono text-xs' style={{ left: `${col.x}%`, top: 0, color: col.bright ? `${NOPING_GREEN}30` : `${NOPING_GREEN}20`, writingMode: 'vertical-lr' as const, letterSpacing: '0.3em', textShadow: col.bright ? `0 0 6px ${NOPING_GREEN}40` : 'none' }} animate={{ y: ['-30vh', '130vh'] }} transition={{ duration: col.speed, delay: col.delay, repeat: Infinity, ease: 'linear' as const }}>
          {col.chars.join('')}
        </motion.div>
      ))}
      {Array.from({ length: 30 }).map((_, i) => (
        <motion.div key={`mx-spark-${i}`} className='absolute rounded-full' style={{ width: 2, height: 2, left: `${(i * 3.4) % 100}%`, top: `${(i * 3.5) % 100}%`, background: NOPING_GREEN }} animate={{ opacity: [0, 0.6, 0], scale: [0.5, 1.2, 0.5] }} transition={{ duration: 1.5 + (i % 4) * 0.5, delay: (i % 8) * 0.7, repeat: Infinity, ease: 'easeInOut' as const }} />
      ))}
    </div>
  );
}
